import { type IDeposit } from '@recargas-dominicanas/core/types';
import { formatCurrency, formatDate } from '@recargas-dominicanas/core/utils';
import { CellButton, CellImage, TableHeader } from '@recargas-dominicanas/core/components';
import { TableRow } from '@recargas-dominicanas/core/components';
import { Table } from '@recargas-dominicanas/core/components';
import { Cell } from '@recargas-dominicanas/core/components';
import { style } from './customer-deposits.module.css';
import { useState } from 'react';
import { RegisterDepositModal } from './register-deposit-modal/register-deposit-modal.component';

interface Props {
  customerId: number;
  deposits: IDeposit[];
  onUpdate: () => void;
}

export function CustomerDeposits(props: Props) {

  const { 
    customerId, 
    deposits, 
    onUpdate 
  } = props;

  const [openRegisterDepositModal, setOpenRegisterDepositModal] = useState(false);

  return (
    <div className={style.container}>
      <Table style={style.table}>
        <TableHeader style={style.tableHeader}>
          <span>Banco</span>
          <span>Balance</span>
          <span>Fecha</span>
          <span>Referencia</span>
          <span>Descripción</span>
          <CellButton 
            text='Registrar deposito'
            onClick={() => setOpenRegisterDepositModal(true)}/>
        </TableHeader>
        <tbody>
          {
            deposits?.map(deposit => (
              <TableRow key={deposit.id}>
                <CellImage src={deposit.bankAccount.bank.image}/>
                <Cell weight='medium' color='green' text={formatCurrency(deposit.balance.amount)}/>
                <Cell text={formatDate(deposit.date)}/>
                <Cell className={style.reference} text={deposit.reference}/>
                <Cell className={style.reference} text={deposit.description}/>
                <Cell text=''/>
              </TableRow>
            ))
          }
        </tbody>
      </Table>
      <RegisterDepositModal
        open={openRegisterDepositModal}
        customerId={customerId}
        onUpdate={onUpdate}
        onClose={() => setOpenRegisterDepositModal(false)}/>
    </div>
  );
}
